import { ApolloQueryResult } from '@apollo/client';
import React from 'react';
import { VersionsQuery } from '../graphql/types';

interface VersionsData {
  versions?: VersionsQuery['versions'] | undefined;
  loading?: boolean;
  poll?: () => void;
  isSavingOrRestoring: boolean;
  latestType?: 'restore' | 'save' | null;
  refetch?: () => Promise<ApolloQueryResult<VersionsQuery>>;
}

export const VersionsContext = React.createContext<VersionsData>({
  isSavingOrRestoring: false,
});
VersionsContext.displayName = 'VersionsContext';

export const useVersionsContext = () => React.useContext(VersionsContext);
